import React, { useContext, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import ContentLoader from "react-content-loader";

import useWorks from "../../hooks/useWorks";
import useUsers from "../../hooks/useUsers";
import useJournals from "../../hooks/useJournals";
import AppContext from "../../AppContext";
import { langComponent } from "../../constants";
import { CartContext } from "../../contexts/CartContext";

//component
import Card from "./Card";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

function Recommended({ categoryId, workId, loading, setLoadRecommended }) {
  const { queryWorks } = useWorks();
  const { queryUsers, queryCompanies } = useUsers();
  const { queryJournals } = useJournals();
  const { setIsFetchDetail } = useContext(CartContext);

  const { getLang, user } = useContext(AppContext);
  const TranslationCommon = getLang(langComponent.common);

  const [works, setWorks] = useState([]);
  const [journals, setJournals] = useState([]);

  useEffect(() => {
    fetchData();
  }, [workId, categoryId, user?.id]);

  const fetchData = async () => {
    setIsFetchDetail(false);
    const { data: _works } = await queryWorks(
      {
        "designType.workExchange": {
          $in: [categoryId],
        },
        _id: {
          $ne: workId,
        },
        deleted: false,
        active: true,
      },
      1,
      3,
      {
        name: 1,
        createdBy: 1,
        desc: 1,
        brief: 1,
        price: 1,
        banner: 1,
        program: 1,
        renderer: 1,
        views: 1,
        designType: 1,
        discount: 1,
        createdOn: 1,
        company: 1,
        score: 1,
      },
      {
        views: -1,
      }
    );

    const { data: _users } = await queryUsers(
      { _id: { $in: _works.map((d) => d.createdBy) } },
      1,
      _works.length,
      { firstname: 1, surname: 1, avatar: 1 }
    );

    const { data: companies } = await queryCompanies(
      {
        _id: {
          $in: _works.map((d) => d.company ?? d.createdBy),
        },
      },
      null,
      -1,
      {
        _id: 1,
        name: 1,
        logo: 1,
      }
    );

    const _workIdList = _works.map((item) => item._id);

    if (user?._id) {
      const { data: _journals } = await queryJournals({
        "details.work": {
          $in: _workIdList,
        },
        company: user?.company, // * Company
        createdBy: user?._id, // * User ที่ login
        active: true,
        deleted: false,
        status: 2,
      });
      setJournals(_journals);
    }

    setWorks(
      _works.map((w) => {
        const userFound = _users.find((u) => u._id === w.createdBy);
        const _company = companies.find(
          (company) => w?.company === company._id
        );

        return {
          ...w,
          user: _company
            ? {
                name: _company.name,
                avatar: _company.logo,
              }
            : {
                name: `${userFound.firstname} ${userFound.surname}`,
                avatar: userFound.avatar,
              },
        };
      })
    );

    setIsFetchDetail(true);
  };

  if (!works || works?.length === 0) {
    return <></>;
  }

  return (
    <div className="work-exchange-recommended">
      <div className="work-exchange-recommended-header">
        {TranslationCommon("Recommended")}
      </div>
      <div className="work-exchange-recommended-section">
        <div className="work-exchange-recommended-section-slider">
          <>
            {loading ? (
              <>
                {works?.length > 0 && (
                  <Swiper
                    grabCursor={true}
                    centeredSlides={false}
                    slidesPerView={1}
                    spaceBetween={20}
                    navigation={false}
                    pagination={{ clickable: true }}
                    modules={[Pagination, Navigation, Autoplay]}
                    loop={true}
                    speed={1000}
                    autoplay={{
                      delay: 5000,
                      disableOnInteraction: false,
                      pauseOnMouseEnter: true,
                    }}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                      },
                      768: {
                        slidesPerView: 2,
                      },
                      1200: {
                        slidesPerView: 3,
                      },
                    }}
                  >
                    {works?.map((work, index) => (
                      <SwiperSlide key={index}>
                        <Card
                          {...work}
                          creator={work.user}
                          workJournals={journals}
                          isRecommended={true}
                          setLoadRecommended={setLoadRecommended}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                )}
              </>
            ) : (
              <div className="work-exchange-recommended-loader">
                {works.length > 0 &&
                  works.map((work, index) => {
                    if (index < 3) {
                      return (
                        <ContentLoader viewBox="0 0 620 782">
                          <rect
                            x="0"
                            y="0"
                            rx={20}
                            ry={20}
                            width="620"
                            height="100%"
                          />
                        </ContentLoader>
                      );
                    }
                  })}
              </div>
            )}
          </>
        </div>
      </div>
    </div>
  );
}

Recommended.propTypes = {};

export default Recommended;
